const RADIUS = 54;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

type Props = {
  usedRatio: number;
};

export const AIUsageDonutChart: React.FC<Props> = ({ usedRatio }: Props) => {
  const clampedRatio = Math.min(Math.max(usedRatio, 0), 1);
  const percent = Math.floor(clampedRatio * 100);

  return (
    <svg viewBox="0 0 140 140" className="size-40" role="img" aria-label={`${percent}%`}>
      <circle cx="70" cy="70" r={RADIUS} fill="none" strokeWidth="14" className="stroke-gray-200" />
      <circle
        cx="70"
        cy="70"
        r={RADIUS}
        fill="none"
        strokeWidth="14"
        strokeLinecap="round"
        strokeDasharray={CIRCUMFERENCE}
        strokeDashoffset={CIRCUMFERENCE * (1 - clampedRatio)}
        transform="rotate(-90 70 70)"
        className={clampedRatio >= 1 ? 'stroke-red-500' : clampedRatio >= 0.8 ? 'stroke-yellow-500' : 'stroke-brand'}
      />
      <text x="70" y="70" textAnchor="middle" dominantBaseline="central" className="fill-gray-800 text-2xl font-bold">
        {`${percent}%`}
      </text>
    </svg>
  );
};
